import { stateOptions } from '../../helper/states'

export default {
  name: 'UiFormAddress',

  inject: {
    uiForm: {
      default: '',
    },
  },

  // language=HTML (for PhpStorm)
  template: `
    <div>
      <ui-form-item :label="addressLabel" :prop="streetProp">
        <ui-form-input v-model="address.street" />
        <ui-form-input
          v-if="street2Visible"
          v-model="address.street2"
          placeholder="Apt, Suite, Floor, Bldg, etc"
          aria-label="Apartment, Suite, Floor, Building, Etc"
        />
      </ui-form-item>

      <div v-if="!stackCityStateZip" class="row flush">
        <div class="small-12 medium-4 columns">
          <ui-form-item label="City" :prop="cityProp">
            <ui-form-input v-model="address.city" />
          </ui-form-item>
        </div>
        <div class="small-12 medium-4 columns">
          <ui-form-item label="State" :prop="stateProp">
            <ui-form-select
              v-model="address.state"
              :options="stateOptions"
              input-class="inline" />
          </ui-form-item>
        </div>
        <div v-if="zipVisible" class="small-12 medium-4 columns">
          <ui-form-item label="Zip" :prop="zipProp">
            <ui-form-input v-model="address.zip" />
          </ui-form-item>
        </div>
      </div>

      <template v-else>
        <ui-form-item label="City" :prop="cityProp">
          <ui-form-input v-model="address.city" />
        </ui-form-item>

        <ui-form-item label="State" :prop="stateProp">
          <ui-form-select
            v-model="address.state"
            :options="stateOptions"
            input-class="inline" />
        </ui-form-item>

        <ui-form-item label="Zip" :prop="zipProp" v-if="zipVisible">
          <ui-form-input v-model="address.zip" />
        </ui-form-item>
      </template>
    </div>
  `,

  props: {
    address: {
      type: Object,
      required: true,
      default() {
        return {
          street: null,
          street2: null,
          city: null,
          state: null,
          zip: null,
        }
      },
    },

    addressLabel: {
      type: String,
      default: 'Address',
    },

    propPrefix: {
      type: String,
      default: null,
    },

    street2Visible: {
      type: Boolean,
      default: true,
    },

    zipVisible: {
      type: Boolean,
      default: true,
    },

    stackCityStateZip: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    stateOptions() {
      return stateOptions
    },

    streetProp() {
      return this.propPrefix ? `${this.propPrefix}.street` : null
    },
    street2Prop() {
      return this.propPrefix ? `${this.propPrefix}.street2` : null
    },
    cityProp() {
      return this.propPrefix ? `${this.propPrefix}.city` : null
    },
    stateProp() {
      return this.propPrefix ? `${this.propPrefix}.state` : null
    },
    zipProp() {
      return this.propPrefix ? `${this.propPrefix}.zip` : null
    },
  },
}
